import {
  Box,
  CloseButton,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import React, { useContext, useState } from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { PrimaryButton } from '../../../components/CustomButton';
import { infoNotifier } from '../../../components/NotificationHandler';
import { AuthContext } from '../../../context/authContext';
import { UserProfileContext } from '../../../context/userProfileContext';
import { buyPoints, verifyWalletPayment } from '../service';

const RedirectToPaymentPageModal = ({ onClose, setSuccess, setReload }) => {
  const { userInfo } = useContext(AuthContext);
  const { userProfile } = useContext(UserProfileContext);
  const [pointsAmount, setPointsAmount] = useState(500);
  const [loading, setLoading] = useState(false);
  const [authorizationUrl, setAuthorizationUrl] = useState('');
  const [payStackModalOpen, setPayStackModalOpen] = useState(false);
  const [referenceCode, setReferenceCode] = useState('');
  const [transactionFee, setTransactionFee] = useState(0);
  const { email, tenantName } = userProfile;
  const { userId } = userInfo;
  const navigate = useNavigate();

  useEffect(() => {
    // const rate = 0.015;
    const fixedCharge = 100;
    const charges = 0.015 * pointsAmount;

    if (pointsAmount <= 2000) {
      setTransactionFee(charges);
      return;
    } else if (charges > 2000) {
      setTransactionFee(2000 + fixedCharge);
      return;
    } else {
      setTransactionFee(charges + fixedCharge);
    }
  }, [pointsAmount]);

  const handleGotoPayment = () => {
    if (pointsAmount < 500) {
      infoNotifier('you cannot buy less than 500 points');
      return;
    }

    if (!email) {
      infoNotifier('please set your profile and add your Email first ');
      return;
    }

    const payload = {
      amount: Number(pointsAmount),
      userId,
      email,
      tenantName,
    };

    console.log('payload', payload);

    if (!payload.amount) {
      infoNotifier('please enter the number of points you want to buy ');
      return;
    }
    buyPoints(
      payload,
      setLoading,
      setAuthorizationUrl,
      setPayStackModalOpen,
      setReferenceCode
    );
  };

  const verifyAndCloseModal = () => {
    const payload = { reference: referenceCode, userId };
    verifyWalletPayment(payload, setSuccess, navigate).then(() => setReload());
  };

  return (
    <>
      <Flex justify='right'>
        <CloseButton _focus={{ border: 'none' }} onClick={onClose} />
      </Flex>

      {/* <Text textAlign='center' textDecoration='underline' fontWeight='600'>
        Notice
      </Text>
      <Text textAlign='center'>One Point Is Equivalent To 1 Naira</Text> */}
      <FormControl my='10%' isRequired>
        <FormLabel fontWeight='600' m='0'>
          Amount (&#8358;500 or more)
        </FormLabel>
        <Input
          my='2'
          type='number'
          min='500'
          value={pointsAmount}
          onChange={(e) => setPointsAmount(e.target.value)}
          placeholder='enter point amount'
        />
        <Text textAlign={'right'} fontWeight='600'>
          Paystack Charge {transactionFee.toFixed(2)}
        </Text>
      </FormControl>

      <PrimaryButton
        isLoading={loading}
        btnText='Go to payment'
        onClick={handleGotoPayment}
      />

      <Text pt='10%' fontSize='12px' textAlign={'center'}>
        You will be redirected to payment page
      </Text>

      <Modal
        isOpen={payStackModalOpen}
        isCentered
        onClose={verifyAndCloseModal}
        size='sm'
        closeOnOverlayClick={false}
        scrollBehavior='outside'
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Payment checkout</ModalHeader>
          <ModalCloseButton onClick={onClose} />
          <ModalBody p='0' pb='2 !important'>
            <Box w='100%' pb='2 !important'>
              <iframe
                src={authorizationUrl}
                frameBorder='0'
                width='100%'
                height='500'
                title='payment checkout'
              ></iframe>
            </Box>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default RedirectToPaymentPageModal;
